import { useState } from "react";
import axios from "./axios";
import { toast } from "sonner";

export const useGenerateCampaignGame = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  const generateCampaignGame = async ({
    token,
    route,
    is_link,
    campaign_id,
    game_id,
    user_id,
  }) => {
    try {
      setLoading(true);
      const res = await axios.post(
        `/audiences/play-game${route ? route : ""}`,
        JSON.stringify({
          game_id,
          campaign_id,
          is_link,
          user_id,
        }),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (res.status === 200) {
        setLoading(false);
        setData(res.data);
      } else {
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      toast.error(err.response.data.message);
      setData(null);
    }
  };

  return { generateCampaignGame, data, setData, loading, setLoading };
};
